import React from 'react';
import { AuthProvider } from './context/AuthContext';
import {ToastContainer} from 'react-toastify';
import Router from './components/Router';
import 'react-toastify/dist/ReactToastify.css';

// app_version: 2025-03-06 001
const App = () => {
  return (
    <AuthProvider>
        <div>
            <Router />
            <ToastContainer />
        </div>
    </AuthProvider>
  );
}

export default App;
